module.exports = __webpack_public_path__ + "static/img/car.2ee6a65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/car.png
// module id = 8IJ2
// module chunks = 5